import { FunctionComponent, ReactNode } from 'react';
import Subtitle from 'src/designSystem/Subtitle';

type Props = {
  title?: ReactNode;
  description?: ReactNode;
  illustration?: ReactNode;
};

const PanelHeader: FunctionComponent<Props> = ({
  title,
  description,
  illustration,
}) => (
  <div className="flex flex-col items-center gap-4 text-center">
    {illustration}
    <div className="flex flex-col gap-3">
      {title && (
        <h2 className="m-0 text-balance text-xl font-bold text-structural-darkest">
          {title}
        </h2>
      )}
      {description && <Subtitle>{description}</Subtitle>}
    </div>
  </div>
);

export default PanelHeader;
